// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cb00d-button{position:relative;z-index:10;height:23px;line-height:11px;font-size:12px}", "",{"version":3,"sources":["webpack://./app/components/MatchPreview/MatchActionTrader/style.scss"],"names":[],"mappings":"AAAA,cACE,iBAAA,CACA,UAAA,CACA,WAAA,CACA,gBAAA,CACA,cAAA","sourcesContent":[".button {\n  position: relative;\n  z-index: 10;\n  height: 23px;\n  line-height: 11px;\n  font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": "cb00d-button"
};
export default ___CSS_LOADER_EXPORT___;
